export default "__VITE_ASSET__DiKkAFWM__"